import AllBesmart from "../components/AllBesmart";
import useAllBesmart from "../hooks/useAllBesmart";

const AllBesmartPages = () => {
    const AllBesmartProps = useAllBesmart();
    return <AllBesmart {...AllBesmartProps}/>
};

export default AllBesmartPages;